import { ProductCategorySlug } from "@/constants/enums";
import type { Product } from "@/types/products";

type Path = {
  path: string;
  label: string;
};

interface BreadcrumbsViewModel {
  breadcrumbs: Path[];
}

/**
 * 商品詳細頁預設麵包屑：首頁 > 所有商品。
 * 若該商品有相關分類，僅顯示排除現貨分類後的最後兩層分類，第一個分類會直接新增，而後續的分類則會嵌套在第一個分類的路徑下。
 * eg. 首頁 > 所有商品 > 第一層分類(預期國家) > 第二層分類(預期國家名稱)
 *
 * 注意：TODO 理想情況應由後端 API 提供麵包屑結構或完整分類樹。
 * 目前的實作假設後台限制分類層級最多兩層，且商品僅屬於單一分類，不會跨分類或多分類。
 */
const generateBreadcrumbs = (product: Product | null) => {
  const defaultBreadcrumbs = [
    { label: "首頁", path: "/" },
    { label: "所有商品", path: "/shop" },
  ];

  if (!product) return defaultBreadcrumbs;

  const categories = product.categories;
  if (categories.length === 0) return defaultBreadcrumbs;

  const breadcrumbCategories: Path[] = [];
  const filteredCategories = categories
    .filter((cat) => cat.slug !== ProductCategorySlug.ReadyToShip)
    .slice(-2); // 去除現貨分類後，取最後兩個分類，預期拿到 國家 > 國家名稱

  filteredCategories.forEach((cat, index) => {
    const categoryPath =
      index === 0 ? `/product-category/${cat.slug}` : `${breadcrumbCategories[0].path}/${cat.slug}`;
    breadcrumbCategories.push({ label: cat.name, path: categoryPath });
  });

  return [...defaultBreadcrumbs, ...breadcrumbCategories];
};

const useBreadcrumbs = ({ product }: { product: Product | null }): BreadcrumbsViewModel => {
  const breadcrumbs = generateBreadcrumbs(product);

  return { breadcrumbs };
};

export default useBreadcrumbs;
